import src from "IMAGE";
export default { src, width: 100, height: 100, blurDataURL: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==", blurWidth: 1, blurHeight: 1 }
